import { PublicClientApplication, Configuration } from '@azure/msal-browser'
import {
  MSAL_CLIENT_ID,
  MSAL_AUTHORITY,
  MSAL_REDIRECT_URI,
} from 'src/constants'

const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: MSAL_AUTHORITY,
    redirectUri: MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    secureCookies: false,
  },
  system: {
    allowRedirectInIframe: true,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: true,
    tokenRenewalOffsetSeconds: 300,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        if (level === 0) {
          console.error(message)
        }
      },
      logLevel: 0,
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization error:', error)
})
